import React, { useState } from "react";
import SortingIcon from "../../../assets/icons/icon-sort-copy-2.svg";
import { Typography } from "src/latest/src/components";

interface ContentSortingProps {
    selectedOption: "EARLIEST" | "MOST";
    handleSelect: (option: "EARLIEST" | "MOST") => void;
}

const ContentSorting: React.FC<ContentSortingProps> = ({ selectedOption, handleSelect }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
        <div className="dropdown">
            <div
                className="dropdown-header ca-dropdown-header"
                onClick={() => setIsOpen(!isOpen)}
            >
                <img className="filter-icon" src={SortingIcon} alt="" />
            </div>
            {isOpen && (
                <ul className="dropdown-list" onMouseLeave={() => setIsOpen(false)}>
                    <Typography variant="size-12" className="fw-semibold ms-1 ">SORT BY</Typography>
                    <li
                        className={`dropdown-list-item ${selectedOption === "MOST" ? "font-weight-bold" : ""}`}
                        onClick={() => handleSelect("MOST")}
                    >
                        {"Most Availability"}
                    </li>
                    <li
                        className={`dropdown-list-item ${selectedOption === "EARLIEST" ? "font-weight-bold" : ""}`}
                        onClick={() => handleSelect("EARLIEST")}
                    >
                        {"Soonest Availablity"}
                    </li>
                   
                </ul>
            )}
        </div>
    );
};

export default ContentSorting;

